import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { N0CheckinDocCheckResponse, N0CheckinResponse, N0CheckinStatus } from '@models/check-in.models';
import { CheckInDocCheckRequest, CheckInPassengersRequestV3 } from '@models/requests/check-in-passengers-request.model';
import { ApiResponse } from '@models/responses/api-response.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckInService {
  private static readonly CHECK_IN_CONTROLLER_ROOT = 'v1/checkin';

  constructor(private httpClient: HttpClient) {}

  checkInPassengers(
    request: CheckInPassengersRequestV3,
  ): Observable<ApiResponse<N0CheckinResponse>> {
    return this.httpClient.post<ApiResponse<N0CheckinResponse>>(
      `${EnvironmentService.environment.apiBaseUrl}${CheckInService.CHECK_IN_CONTROLLER_ROOT}?returnBoardingPasses=true`,
      request,
    );
  }

  getCheckInStatus(): Observable<ApiResponse<N0CheckinStatus[]>> {
    return this.httpClient.get<ApiResponse<N0CheckinStatus[]>>(
      `${EnvironmentService.environment.apiBaseUrl}${CheckInService.CHECK_IN_CONTROLLER_ROOT}/status`,
    );
  }

  autoAssignSeats(): Observable<ApiResponse<null>> {
    return this.httpClient.post<ApiResponse<null>>(
      `${EnvironmentService.environment.apiBaseUrl}${CheckInService.CHECK_IN_CONTROLLER_ROOT}/seats`,
      null,
    );
  }

  docCheck(request: CheckInDocCheckRequest) {
    return this.httpClient.post<ApiResponse<N0CheckinDocCheckResponse>>(
      `${EnvironmentService.environment.apiBaseUrl}${CheckInService.CHECK_IN_CONTROLLER_ROOT}/doccheck`,
      request,
    );
  }
}
